import { render, staticRenderFns } from "./NotaDialog.vue?vue&type=template&id=6c69d0b5&"
import script from "./NotaDialog.vue?vue&type=script&lang=js&"
export * from "./NotaDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QBar,QSpace,QBtn,QTooltip,QSeparator,QCardSection,QEditor,QCardActions,QInnerLoading,QSpinner,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QBar,QSpace,QBtn,QTooltip,QSeparator,QCardSection,QEditor,QCardActions,QInnerLoading,QSpinner})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
